import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oppo-gulf-footer',
  templateUrl: './oppo-gulf-footer.component.html',
  styleUrls: ['./oppo-gulf-footer.component.scss']
})
export class OppoGulfFooterComponent implements OnInit {
  constructor() { }
  ngOnInit(): void {
  }

}
